import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import Done from "@material-ui/icons/Done";
import SwitchOnKitSectionHeader from "./SwitchOnKitSectionHeader";

const COLOUR_CODES = ["AB_PROCESSOR_COLOUR", "AB_HP_CABLE_COLOUR"];
const splitOptions = (value) => (value || "").split("|").filter(Boolean);

// Adapted from ITEShellColour. Processor colours use ShellColours and cable
// colours use FaceplateColours from the existing configuration-group API.
const SwitchOnKitColours = ({ rightSelected, leftSelected, linked, setLinked, getOptionsForSide, optionVisible, selectedOptions, setOption, configurationGroupRight, configurationGroupLeft }) => {
  const renderSide = (side) => getOptionsForSide(side)
    .filter((option) => COLOUR_CODES.includes(option.Code) && optionVisible(option, side))
    .sort((a, b) => COLOUR_CODES.indexOf(a.Code) - COLOUR_CODES.indexOf(b.Code))
    .map((option) => {
      const selected = selectedOptions[side][option.Name];
      const config = side === "R" ? configurationGroupRight : configurationGroupLeft;
      const order = splitOptions(option.Options).map((value) => value.split("-").pop().trim());
      const source = option.Code === "AB_PROCESSOR_COLOUR" ? (config && config.ShellColours) || [] : (config && config.FaceplateColours) || [];
      const rank = (code) => {
        const index = order.indexOf(code);
        return index === -1 ? Number.MAX_SAFE_INTEGER : index;
      };
      const colours = source.slice().sort((a, b) => rank(a.Code) - rank(b.Code));
      const active = colours.find((colour) => colour.Code === selected);
      const label = option.Code === "AB_PROCESSOR_COLOUR" ? "Speech Processor Colour" : "Headpiece Cable Colour";
      return <Row className={side === "R" ? "ite-shell-colour-row-right" : "ite-shell-colour-row-left"} key={`${side}-${option.Code}`}>
        <Col xs={12}><p>{label}: {active && <strong>{active.Name}</strong>}</p></Col>
        {colours.map((colour) => <Col key={colour.Code} xs={3}><button type="button" className="switch-on-kit-colour-button" title={`${colour.Name} - ${colour.Code}`} onClick={() => setOption(side, option, colour.Code)}>
          <div className={`ite-shell-colour-box ${selected === colour.Code ? "active" : ""}`} style={colour.ImagePath ? { backgroundImage: `url('${colour.ImagePath}')`, backgroundSize: "contain" } : { backgroundColor: `rgb(${colour.Rgb})` }}>
            <div className="ite-shell-colour-box-text">{selected === colour.Code && <Done className="icon-shadow" />}</div>
          </div>
        </button></Col>)}
      </Row>;
    });

  return <div className="switch-on-kit-option-section ite-shell-colour-component-main-div">
    <SwitchOnKitSectionHeader title="Choose colours" rightSelected={rightSelected} leftSelected={leftSelected} linked={linked} setLinked={setLinked}>
      <Col md={6}>{rightSelected && renderSide("R")}</Col>
      <Col md={6} className="left-side">{leftSelected && renderSide("L")}</Col>
    </SwitchOnKitSectionHeader>
  </div>;
};

SwitchOnKitColours.propTypes = {
  rightSelected: PropTypes.bool, leftSelected: PropTypes.bool, linked: PropTypes.bool, setLinked: PropTypes.func,
  getOptionsForSide: PropTypes.func, optionVisible: PropTypes.func, selectedOptions: PropTypes.object,
  setOption: PropTypes.func, configurationGroupRight: PropTypes.object, configurationGroupLeft: PropTypes.object,
};
export default SwitchOnKitColours;
